<template>
	<div class="block">
		<h2 v-text="title" class="heading2"></h2>
		<div class="more">
			<a v-bind:href="'/s/blogs/blog_index/' + name" target="_blank"><i class="glyphicon glyphicon-arrow-right"></i> 一覧を見る</a>
		</div>
		<ul class="linkList linkList--border">
			<li v-for="item in profiles">
				<!-- <a v-link="item.permalink"> -->
				<a v-bind:href="item.permalink" target="_blank">
					<div class="flexColumn">
						<div class="flexColumn__col1">
							<img v-bind:src="item.thumbnail" class="img-responsive" alt="">
						</div>
						<div class="flexColumn__col2">
							<h4 v-text="item.entrytitle" class="heading3 heading3--bold"></h4>
							<p v-text="item.name" class="pr"></p>
							<p v-text="item.publicdate | dateFormat" class="pr"></p>
						</div>
					</div>
				</a>
			</li>
		</ul>
	</div>
</template>

<script>
module.exports = {
	props: {
		name: {
			type: String,
			required: true
		},
		title: {
			type: String,
			required: true
		}
	},
	data: function(){
		return {
			profiles: []
		};
	},
	created: function() {
	},
	ready: function(){
		var devmode = this.devMode();
		var url = this.createJsonPath(devmode);

		this.getJson(url, devmode);
	},
	methods: {
		devMode: function(){
			return this.$route.devmode;
		},
		createJsonPath: function(devmode){
			// GET request
			var host = (document.location.protocol === 'https:') ? 'https:' : 'http:';
			var hostname = document.location.hostname;
			var url = this.$route.devmode ? '/static/json/sample_blog_' + this.name + '.json' : host + '//' + hostname + '/s/api/blog_entry/' + this.name;
			return url;
		},
		getJson: function(url, devmode){
			this.$http.get(url).then(function(response) {
				// success callback
				// console.log(response.statusText);
				var json = response.data;
				// console.log(json);
				var dataObj = [];

				for (var i in json){
					var thumbFileName = '';
					if (json[i].Blogs.head_image){
						thumbFileName = '/s/img/blog/' + json[i].Blogs.head_image.replace(/^(.+)(\.[a-z]+)$/, '$1_thumbnail$2');
					} else if (json[i].Profiles.img_1){
						thumbFileName = '/s/img/studio/' + json[i].Profiles.img_1.replace(/^(.+)(\.[a-z]+)$/, '$1_thumbnail$2');
					} else {
						thumbFileName = '/static/images/thumb/no_image_r.jpg';
					}

					dataObj[i] = {
						id: json[i].Profiles.id,
						permalink: '/s/blogs/entry/' + json[i].Blogs.id, // ブログ記事
						// permalink: '/detail/' + json[i].Profiles.id, // スタジオ詳細
						entrytitle: json[i].Blogs.title,
						publicdate: json[i].Blogs.public_date,
						name: json[i].Profiles.name,
						promoword: json[i].Profiles.promoword,
						thumbnail: thumbFileName
					};
				}
				// console.log(dataObj);

				this.$set('profiles', dataObj);
			}, function (response) {
				// error callback
				console.log(response.statusText);
				console.log('データの取得に失敗しました');
			});
		}
	}
};
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// widget_bloginfo.vue?6a62c5b2